import CircularProgress from '@material-ui/core/CircularProgress';
import styled from '@emotion/styled';
import { Magnetic } from "../../styles";
export const FlyoutDropdown = styled('input') `
	display: inline-block;
	cursor: ${Magnetic.buttonBaseCursor};
	width: 315px;
	padding-right: ${Magnetic.spacer16};

	&:disabled {
		opacity: 1;
		-webkit-text-fill-color: ${Magnetic.disabledFontColor};
	}
`;
export const FlyoutArrow = styled('div') `
	margin-left: -15px;
	margin-top: ${Magnetic.spacer12};
	border: 5px ${Magnetic.baseBorderStyle} transparent;
	border-left-color: ${Magnetic.colorBlack};
	position: absolute;
	display: inline;
	pointer-events: none;
	@media (max-width: 480px) {
		transform: rotate(90deg);
		left: 300px;
		display: none;
	}
	@media (max-width: 300px) {
		transform: rotate(90deg);
		left: 310px;
		margin-top: ${Magnetic.spacer20};
	}
`;
export const StyledCircularProgress = styled(CircularProgress) `
	display: inline-block;
	top: 0.4em;
	left: -2em;
	position: relative;
`;
export const FlyoutContainer = styled('div') `
	width: 100%;
	@media (max-width: 480px) {
		display: block;
		margin-left: 0;
	}
	display: inline;
	position: absolute;
	margin-left: ${Magnetic.spacer08}; //adds space between flyout and input box
	z-index: 75; //md-dialog's z-index is set to 80, so we want this to appear behind it.
	.selectable-item-triangle {
		@media (max-width: 480px) {
			display: none;
		}
		position: absolute;
		border-top: 17px ${Magnetic.baseBorderStyle} transparent; // left arrow slant
		border-bottom: 17px ${Magnetic.baseBorderStyle} transparent; // right arrow slant
		border-right: 10px ${Magnetic.baseBorderStyle} ${Magnetic.colorBrand50}; // right arrow slant
	}

	ul {
		list-style: none;
		overflow: auto;
		//puts flyout box arrow in correct position
		margin-left: 10px;
		border: 2px ${Magnetic.baseBorderStyle} ${Magnetic.colorBrand50};
		//creates scrollbar and handles overhang
		-webkit-overflow-scrolling: touch;
		@media (max-width: 480px) {
			margin-left: 1px;
			max-height: 232px;
		}
		li {
			background-color: ${Magnetic.colorMocha5};
			padding: ${Magnetic.spacer08}; //adds space around flyout text
			border-top: ${Magnetic.baseBorderWidth} ${Magnetic.baseBorderStyle} ${Magnetic.colorMocha02c};
			cursor: ${Magnetic.buttonBaseCursor};

			&:first-of-type {
				border-top: none;
			}

			&:hover {
				background-color: ${Magnetic.colorBrand10};
			}
		}
	}
`;
//# sourceMappingURL=Flyout.style.js.map